import { Route } from '@angular/router'
import { TaxonomyDetailComponent } from '../taxonomy-detail/taxonomy-detail.component'
import { createTaxonomyDefinition } from '../taxonomy-detail/taxonomy.definition'

import { PermissionGuard } from '../../abacus/guards/permission.guard'
import { AuthGuard } from '../../abacus/guards/auth.guard'

import { AIPrincipleListComponent } from './ai-principle-list/ai-principle-list.component'

export const aiPrincipleRoutes: Route[] = [
  {
    path: 'ai-principles',
    component: AIPrincipleListComponent,
    canActivate: [AuthGuard, PermissionGuard],
    data: {
      permission: 'browsePolicyInitiativeTaxonomies'
    }
  },
  {
    path: 'ai-principles/:id/edit',
    redirectTo: 'ai-principles/:id',
    pathMatch: 'full'
  },
  {
    path: 'ai-principles/:id',
    component: TaxonomyDetailComponent,
    canActivate: [AuthGuard, PermissionGuard],
    data: {
      definition: createTaxonomyDefinition({
        className: 'AIPrinciple',
        nameSingular: 'AI Principle',
        namePlural: 'AI Principles',
        path: 'ai-principles',
        slug: 'taxonomies/ai-principles',
        title: 'AI Principles'
      }),
      permission: 'readPolicyInitiativeTaxonomies'
    }
  }
]
